<template>
  <div v-if="type === 'tessere'">
    <table>
      <tr
        v-for="(tessera, index) in json"
        :key="`tessera-${index}`"
        :class="index === json.length ? 'last-child' : ''"
      >
        <td width="100px" style="text-align: right">
          <span :style="{ color: tessera.asdTesHexColor }"
            ><b style="font-size: 20px">{{ tessera.asdTesNum }}</b></span
          >
        </td>
        <td width="50px"><img width="50px" :src="tessera.tesseraImage" /></td>
        <td>
          {{ tessera.customers.ragSoc }}
          <br /><span :style="{ color: tessera.asdTesHexColor }"
            ><b>{{ tessera.asdTesTipo }}</b></span
          >
        </td>
        <td>
          {{ $t("start_validity") }}:
          {{ new Date(tessera.dateTes).toLocaleDateString("it") }}<br />
          {{ $t("end_validity") }}:
          {{ new Date(tessera.dateEnd).toLocaleDateString("it") }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "custom-cell-component",
  props: {
    type: String,
    json: [Array, Object],
  },
  data() {
    return {};
  },
  watch: {},
  methods: {},
};
</script>